import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20gradients%20in%20amber%20and%20cream%20tones%2C%20elegant%20flowing%20shapes%2C%20modern%20minimalist%20design%2C%20warm%20atmospheric%20lighting%2C%20digital%20art%20style%2C%20no%20text%20no%20people&width=1800&height=600&seq=cta-bg-edu-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-primary-600/85"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          现在就开始您的学历提升之旅
        </h2>
        <p className="text-white/85 text-sm md:text-base max-w-xl mx-auto mb-8">
          每天都有数千名在职人士通过我们的平台实现学历提升梦想。
          立即咨询，获取专属学历提升方案。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-primary-600 rounded-lg text-base font-medium hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
          >
            免费获取方案
          </Link>
          <a
            href="tel:4008889999"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-lg text-base font-medium hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            400-888-9999
          </a>
        </div>
      </div>
    </section>
  );
}